/* eslint-disable react/prop-types */
import React from 'react';
import moment from 'moment';
import { Tooltip, useId } from '@applyboard/ui-components';
import DropdownSelect from "../../core/input/DropdownSelect";
import { formatDate } from "../../../util/datetime";
import { intake, intakeEsl, isConditional, eslActualStartDate, programActualStartDate } from '@applyboard/ab-common';
import { getIntakeStatusText } from "./utils";
import { _Intake, _Availability, _EducationSpan, _AvailabilitySpan, _ReadOnly } from "./styles";
import { useEventTracker } from '@applyboard/ui-utils';
var date = function date(d) {
  return formatDate(d, 'YYYY-MMM');
};
var renderDate = function renderDate(d) {
  return /*#__PURE__*/React.createElement(_ReadOnly, {
    valid: !!d
  }, d ? date(d) : 'N/A');
};
var getDateContent = function getDateContent(isApplicationSummary, esl, application) {
  if (isApplicationSummary) {
    if (esl) {
      var eslDate = eslActualStartDate(application);
      return eslDate && eslDate.length ? moment(eslDate).format('YYYY-MMM-DD') : 'N/A';
    }
    var programDate = programActualStartDate(application);
    return programDate && programDate.length ? moment(programDate).format('YYYY-MMM-DD') : 'N/A';
  }
  if (esl) {
    return renderDate(intakeEsl(application));
  }
  return renderDate(intake(application));
};
var ApplicationIntake = function ApplicationIntake(_ref) {
  var allowEslEdit = _ref.allowEslEdit,
    application = _ref.application,
    disabled = _ref.disabled,
    dropdownChange = _ref.dropdownChange,
    dropdownOptions = _ref.dropdownOptions,
    dropdownValue = _ref.dropdownValue,
    esl = _ref.esl,
    hideLabel = _ref.hideLabel,
    readOnly = _ref.readOnly,
    showRequired = _ref.showRequired,
    selectedValue = _ref.selectedValue,
    intakeSpecificStatus = _ref.intakeSpecificStatus,
    intakeInfoTooltip = _ref.intakeInfoTooltip,
    shouldShowIntakeStatus = _ref.shouldShowIntakeStatus,
    isApplicationSummary = _ref.isApplicationSummary,
    onBlur = _ref.onBlur,
    onOpen = _ref.onOpen;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var availabilityTooltipId = useId();
  var intakeStatusText = getIntakeStatusText(intakeSpecificStatus);
  return /*#__PURE__*/React.createElement(_Intake, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Availability, {
    hideLabel: hideLabel,
    increaseMinWidth: (intakeStatusText === null || intakeStatusText === void 0 ? void 0 : intakeStatusText.length) > 9 && !esl
  }, /*#__PURE__*/React.createElement(_EducationSpan, null, esl ? 'ESL' : 'Academic'), /*#__PURE__*/React.createElement(Tooltip, {
    id: availabilityTooltipId,
    title: /*#__PURE__*/React.createElement("span", {
      style: {
        whiteSpace: 'pre-wrap'
      }
    }, intakeInfoTooltip)
  }, /*#__PURE__*/React.createElement(_AvailabilitySpan, {
    selectedValue: selectedValue,
    showAvailability: shouldShowIntakeStatus,
    intakeStatus: intakeSpecificStatus,
    "data-testid": esl ? 'esl-intake-status' : 'academic-intake-status',
    onMouseOver: function onMouseOver() {
      trackEvent({
        event: "Single Application - Intakes - Intake Status - ".concat(esl ? 'ESL' : 'Academic', " Tooltip")
      });
    },
    tabIndex: "0",
    "aria-describedby": availabilityTooltipId
  }, intakeStatusText)))), readOnly && getDateContent(isApplicationSummary, esl, application), !readOnly && /*#__PURE__*/React.createElement(DropdownSelect, {
    placeholder: esl ? allowEslEdit || isConditional(application) ? undefined : 'N/A' : undefined,
    disabled: esl && !allowEslEdit && !isConditional(application) || disabled,
    inputValue: dropdownValue,
    options: dropdownOptions,
    onChange: dropdownChange,
    clearable: esl && allowEslEdit,
    noPadding: true,
    required: !(esl && !isConditional(application)) && showRequired,
    noTitle: true,
    onBlur: onBlur,
    onOpen: onOpen
  }));
};
export default ApplicationIntake;